<template>
  <footer class="app-footer ws-grid">
    <span class="app-footer__message">{{ $t('footer.title') }}</span>

    <u-button class="app-footer__button" size="large" dark @click="onActionButtonClick">{{
      $t(actionButtonLabel)
    }}</u-button>

    <div class="app-footer__links footer-links">
      <span class="footer-links__item">© Universkin 2022</span>

      <i18n path="footer.legalAndTermsText" tag="span" class="footer-links__item">
        <a :href="`https://www.skinxs.com/legal/${$i18n.locale}`" target="_blank">
          {{ $t('checkout.legal') }}
        </a>
        <a :href="`https://www.skinxs.com/terms/${$i18n.locale}`" target="_blank">
          {{ $t('footer.termsOfUseLabel') }}
        </a>
      </i18n>

      <a
        class="footer-links__item"
        :href="`https://skinxs.com/terms-of-sales/${$i18n.locale}`"
        target="_blank"
      >
        {{ $t('footer.termsOfSalesLabel') }}
      </a>

      <i18n path="footer.privacyNoticeText" tag="span" class="footer-links__item">
        <a :href="`https://www.skinxs.com/doctor-notice/${$i18n.locale}`" target="_blank">
          {{ $t('footer.doctorsLabel') }}
        </a>
        <a :href="`https://www.skinxs.com/patient-notice/${$i18n.locale}`" target="_blank">
          {{ $t('footer.patientsLabel') }}
        </a>
      </i18n>
    </div>
  </footer>
</template>

<script>
import { UButton } from 'universkin-shared';

const ACTION = {
  GO_TO_CART: 'go-to-cart',
  GO_TO_ROUTINE: 'go-to-routine'
};

export default {
  name: 'AppFooter',
  components: { UButton },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    actionButtonLabel() {
      return this.action === ACTION.GO_TO_CART ? 'action.goToCart' : 'action.goToRoutine';
    }
  },
  methods: {
    onActionButtonClick() {
      this.$emit('action', this.action);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: var(--u-color-grey-900);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px var(--ws-grid-m, 16px) 32px;

  &__message {
    text-align: center;
    margin-bottom: 24px;
    font-family: var(--u-font-family-Helvetica);
    font-size: 24px;
    line-height: 29px;
  }

  &__button {
    margin-bottom: 24px;
  }

  &__links {
    font-family: var(--u-font-family-Helvetica);
    font-size: 14px;
    line-height: 40px;
    color: white;
    text-align: center;
    margin: 0 auto;
  }

  &__links a {
    color: inherit;
  }
}

.footer-links {
  display: flex;
  flex-direction: column;
}

@media (min-width: 600px) {
  .app-footer {
    padding-bottom: 100px;

    &__message {
      width: var(--ws-col-6);
    }
  }
}

@media (min-width: 960px) {
  .app-footer {
    padding-top: 120px;
    padding-bottom: 32px;

    &__message {
      margin-bottom: 48px;
      width: var(--ws-col-10);
      font-size: 48px;
      line-height: 53px;
    }

    &__button {
      margin-bottom: 160px;
    }

    &__links {
      line-height: 18px;
      max-width: 700px;
    }
  }

  .footer-links {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 32px;

    &__item:not(:last-child) {
      margin-inline-end: 24px;
    }
  }
}

@media (min-width: 1200px) {
  .app-footer {
    padding-top: 160px;

    &__message {
      margin-bottom: 86px;
      font-size: 56px;
      line-height: 62px;
    }
  }
}

@media (min-width: 1440px) {
  .app-footer {
    &__message {
      margin-bottom: 56px;
      font-size: 70px;
      line-height: 77px;
    }
  }
}

@media (min-width: 1920px) {
  .app-footer {
    &__message {
      width: var(--ws-col-8);
    }
  }
}
</style>
